export function formatDocumentType(option) {
  if (!option || typeof option !== "string") return "";

  const overrides = {
    DRIVERS_LICENSE: "DRIVING LICENCE", // UK spelling
  };

  if (overrides[option]) {
    return overrides[option];
  }

  return option.replace(/_/g, " ").toUpperCase();
}
